<!--恒岳读书会-->
<template>
    <div class="event-nav-container">
        <div class="museum-title-container" v-show="showMode==='page'">
            <div class="l-museum-title-container">
                <div class="l-t-museum-title-container">恒岳科创会</div>
                <div class="l-b-museum-title-container">科创类主题班会资源</div>
            </div>
            <div class="r-museum-title-container">
                <div  class="back-btn-container" @click="backReadMuseum" >⇦返回</div>
            </div>
        </div>
        <div class="event-content-container" v-show="showMode==='page'">
            <div class="event-content-top-container">
                <div class="event-item-container" v-for="item in itemList.slice(0,1)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg1">
                        <div class="event-title">{{item.itemMonth}}冬日暖阳</div>
                        <div class="event-desc">迎新春</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(1,2)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg2">
                        <div class="event-title">{{item.itemMonth}}新春贺岁</div>
                        <div class="event-desc">早春萌动</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(2,3)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg3">
                        <div class="event-title">{{item.itemMonth}}学雷锋</div>
                        <div class="event-desc">万物生长</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(3,4)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg4">
                        <div class="event-title">{{item.itemMonth}}春雨绵绵</div>
                        <div class="event-desc">春日烂漫</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(4,5)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg5">
                        <div class="event-title">{{item.itemMonth}}劳动光荣</div>
                        <div class="event-desc">感恩母爱</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(5,6)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg6">
                        <div class="event-title">{{item.itemMonth}}欢庆六一</div>
                        <div class="event-desc">毕业季</div>
                    </div>
                </div>
            </div>
            <div class="event-content-bottom-container" v-for="item in itemList.slice(6,7)" :key="item" @click="pageMyjr(item)">
                <div class="event-item-container">
                    <div class="event-item fygf-bg7">
                        <div class="event-title">{{item.itemMonth}}盛夏光年</div>
                        <div class="event-desc">夏日晚风</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(7,8)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg8">
                        <div class="event-title">{{item.itemMonth}}初秋序曲</div>
                        <div class="event-desc">初秋序曲</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(8,9)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg9">
                        <div class="event-title">{{item.itemMonth}}开学季</div>
                        <div class="event-desc">师恩难忘</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(9,10)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg10">
                        <div class="event-title">{{item.itemMonth}}国庆颂歌</div>
                        <div class="event-desc">深秋诗意</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(10,11)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg11">
                        <div class="event-title">{{item.itemMonth}}初冬暖阳</div>
                        <div class="event-desc">初冬暖阳</div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(11,12)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg12">
                        <div class="event-title">{{item.itemMonth}}冬日童话</div>
                        <div class="event-desc">迎新年</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-container" v-show="showMode==='detail'">
            <read-page :item-id="itemId" :item-name="itemName" :mark-info="markInfo"
                       @change-mode="changeModel" />
        </div>
    </div>
</template>
<script>
import {listItemByMuseum} from "@/api/admin/item"
import readPage from "@/components/read/readPage.vue";

export default {
    name:'teaArtEventClub',
    components:{readPage},
    props:{
        museumId:{
            type: String,
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch:{
        museumId(newValue,oldValue){
            this.queryItemList();
        },
        markInfo(newValue,oldValue){
            this.queryItemList();
        },
    },
    mounted() {
    },
    created() {

    },
    data() {
        return {
            showMode:'page',
            itemList:[],
            itemId:'',
            itemName:'',
            markInfo:'pageSub',
        }
    },
    methods: {
        queryItemList(){
            listItemByMuseum({ museumKey: this.museumId }).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode);
        },
        pageMyjr(item){
            this.itemId = item.itemId;
            this.itemName = item.itemName;
            this.markInfo = this.markInfo+new Date();
            this.showMode = 'detail';
            this.$emit('change-mode',this.showMode);
        },
        backReadMuseum(){
            this.$emit('back-read-museum', "homePage");
        },
    }
}
</script>
<style>
.event-nav-container{
    width: 100%;
    height: calc(100vh - 90px);
    background: rgba(255,255,255,.5);

}
.museum-title-container{
    width: 100%;
    height: 70px;
    display: flex;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
}
.l-museum-title-container{
    width: calc(100% - 80px);
    height: 70px;
}
.l-t-museum-title-container{
    width: 100%;
    height: 40px;
    font-weight: bold;
    color: #0d55a4;
    font-size: 17px;
    line-height: 50px;
}
.l-b-museum-title-container{
    width: 100%;
    height: 30px;
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    width: 80px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.back-btn-container{
    width: 80px;
    height: 32px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 15px;
    border-radius: 6px;
    letter-spacing: 3px;
    cursor: pointer;
}

.event-content-container{
    width: 100%;
    height: calc(100% - 70px);
    padding: 20px;
    box-sizing: border-box;
}
.event-content-top-container{
    width: 100%;
    height: 50%;
    display: flex;
    gap: 10px;
}
.event-item-container{
    width: 16.6%;
    height: 100%;
    display: flex;
    border: 10px;
    box-sizing: border-box;
}
.event-item{
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.fygf-bg1{
    background-image: url("../../assets/zxhy/zxhy_1.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg2{
    background-image: url("../../assets/zxhy/zxhy_2.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg3{
    background-image: url("../../assets/zxhy/zxhy_3.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg4{
    background-image: url("../../assets/zxhy/zxhy_4.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg5{
    background-image: url("../../assets/zxhy/zxhy_5.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg6{
    background-image: url("../../assets/zxhy/zxhy_6.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg7{
    background-image: url("../../assets/zxhy/zxhy_7.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg8{
    background-image: url("../../assets/zxhy/zxhy_8.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg9{
    background-image: url("../../assets/zxhy/zxhy_9.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg10{
    background-image: url("../../assets/zxhy/zxhy_10.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg11{
    background-image: url("../../assets/zxhy/zxhy_11.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg12{
    background-image: url("../../assets/zxhy/zxhy_12.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.event-content-bottom-container{
    width: 100%;
    height: 50%;
    display: flex;
    gap: 10px;
}
.event-title{
    width: 100%;
    height: 50px;
    line-height: 60px;
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    color: #0d55a4;
}
.event-desc{
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    color: #9a9a9a;
}
</style>